import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Star: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '32px',
      height: '32px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.3333 28H6.66667C5.19333 28 4 26.8067 4 25.3333V6.66667C4 5.19333 5.19333 4 6.66667 4H25.3333C26.8067 4 28 5.19333 28 6.66667V25.3333C28 26.8067 26.8067 28 25.3333 28Z"
      stroke="#B4EB56"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0012 20.5673L19.2012 22.2353C19.8238 22.5606 20.5518 22.0353 20.4332 21.3473L19.8225 17.8126L22.4118 15.31C22.9158 14.822 22.6385 13.9726 21.9412 13.8726L18.3638 13.3566L16.7638 10.138C16.4518 9.5113 15.5518 9.5113 15.2412 10.138L13.6412 13.3566L10.0638 13.8726C9.36784 13.9726 9.08917 14.8233 9.59317 15.31L12.1825 17.8126L11.5718 21.3473C11.4532 22.0353 12.1812 22.5606 12.8038 22.2353L16.0038 20.5673"
      stroke="#B4EB56"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const StarDark: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '24px',
      height: '24px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.3333 28H6.66667C5.19333 28 4 26.8067 4 25.3333V6.66667C4 5.19333 5.19333 4 6.66667 4H25.3333C26.8067 4 28 5.19333 28 6.66667V25.3333C28 26.8067 26.8067 28 25.3333 28Z"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0012 20.5673L19.2012 22.2353C19.8238 22.5606 20.5518 22.0353 20.4332 21.3473L19.8225 17.8126L22.4118 15.31C22.9158 14.822 22.6385 13.9726 21.9412 13.8726L18.3638 13.3566L16.7638 10.138C16.4518 9.5113 15.5518 9.5113 15.2412 10.138L13.6412 13.3566L10.0638 13.8726C9.36784 13.9726 9.08917 14.8233 9.59317 15.31L12.1825 17.8126L11.5718 21.3473C11.4532 22.0353 12.1812 22.5606 12.8038 22.2353L16.0038 20.5673"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
